import { FC } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getMembershipRedirectPath } from '../utils/membershipRedirect';
import Loading from './Loading';

interface MembershipRouteProps {
  children: React.ReactNode;
}

const MembershipRoute: FC<MembershipRouteProps> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <Loading />;
  }

  const isBusinessOwner =
    user?.membership?.is_member === false &&
    user?.onboarding.subscription_plan === 'business';

  const isMemberWithAccess =
    user?.membership?.is_member === true &&
    user?.membership?.ui_modules?.includes('membership');

  if (isBusinessOwner || isMemberWithAccess) {
    return <>{children}</>;
  }

  return <Navigate to={getMembershipRedirectPath(user?.membership)} replace />;
};

export default MembershipRoute;
